// Projet Chine · Bateaux : bandeau de cookies. Clarity ne se charge qu'après un accord ; le choix est conservé 6 mois.
(function () {
  var CLE = 'pcb-cookies', DUREE = 183 * 864e5;
  function lire() { try { var c = JSON.parse(localStorage.getItem(CLE)); return c && Date.now() - c.date < DUREE ? c.choix : null; } catch (e) { return null; } }
  function noter(choix) { try { localStorage.setItem(CLE, JSON.stringify({ choix: choix, date: Date.now() })); } catch (e) {} }
  function clarity() {
    var id = window.PCB_CLARITY;
    if (!id || window.clarity) return;
    window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    var s = document.createElement('script'); s.async = true; s.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(id); document.head.appendChild(s);
    window.clarity('consentv2', { ad_Storage: 'granted', analytics_Storage: 'granted' });
  }
  function shopify(ok) {
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: false }, function () {});
    });
  }
  function effacer() { ['_clck', '_clsk', 'CLID'].forEach(function (n) { document.cookie = n + '=; Max-Age=0; path=/; domain=.' + location.hostname.replace(/^www\./, ''); document.cookie = n + '=; Max-Age=0; path=/'; }); }
  var bandeau;
  function fermer() { if (bandeau) { bandeau.remove(); bandeau = null; } }
  function choisir(ok) {
    var avant = lire();
    noter(ok ? 'oui' : 'non'); shopify(ok); fermer();
    if (ok) clarity();
    else if (avant === 'oui') { effacer(); location.reload(); }
  }
  function ouvrir() {
    if (bandeau) return;
    bandeau = document.createElement('div');
    bandeau.className = 'pcb pcb-cookies';
    bandeau.setAttribute('role', 'dialog'); bandeau.setAttribute('aria-label', 'Vos cookies');
    bandeau.innerHTML = '<div class="pcb-cookies-carte"><button type="button" class="pcb-cookies-fermer" data-non aria-label="Fermer et refuser les cookies"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button><b>Vos cookies</b><p>Avec votre accord, des cookies de mesure, dont Microsoft Clarity, nous aident à améliorer le site et à suivre nos annonces. Refuser ne change rien à votre navigation. <a href="/policies/privacy-policy">En savoir plus</a></p><div class="pcb-cookies-choix"><button type="button" data-non>Refuser</button><button type="button" data-oui>Accepter</button></div></div>';
    bandeau.querySelectorAll('[data-non]').forEach(function (b) { b.addEventListener('click', function () { choisir(false); }); });
    bandeau.querySelector('[data-oui]').addEventListener('click', function () { choisir(true); });
    document.body.appendChild(bandeau);
  }
  function lienPied() {
    var p = document.querySelector('.pied-bas p:last-child');
    if (!p || p.querySelector('.pied-cookies')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'pied-cookies'; b.textContent = 'Gérer les cookies'; b.addEventListener('click', ouvrir);
    p.appendChild(document.createTextNode(' · ')); p.appendChild(b);
  }
  lienPied();
  var choix = lire();
  if (choix === 'oui') clarity();
  if (!choix) ouvrir();
})();
